import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2895d136"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 text-muted line-height-22 fs-14" }, "Setting", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Log out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _ctx.defaultActive,
    mode: "horizontal",
    router: true,
    class: "h-100 w-100"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainRoute, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (!item.children)
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: item.meta.fullPath,
                class: "text-info"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa_icon, {
                    icon: item.meta.icon
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["index"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createVNode(_component_el_sub_menu, {
        index: "other",
        "popper-class": "sub-router"
      }, {
        title: _withCtx(() => [
          _createVNode(_component_fa_icon, {
            icon: "ellipsis",
            class: "pr-2"
          })
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_menu_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
            class: "line-height-22 fs-14 text-danger"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["default-active"]))
}